export enum NavigationDirection {
  NEXT = 'next',
  PREV = 'prev'
}

export enum ControlsOpacity {
  ACTIVE = 0.9,
  IDLE = 0.25
}

export const CONTROLS_IDLE_TIMEOUT = 2500;
export const SWIPE_THRESHOLD = 50;
export const SWIPE_VERTICAL_THRESHOLD_MULTIPLIER = 1.5;
export const CONTROL_AREA_HEIGHT = 80;
export const CONTROL_AREA_HEIGHT_PERCENT = 0.2;

export const DATA_SWIPE_ATTR = 'data-swipe-target';
export const SNAP_BACK_TRANSITION =
  'transform 0.3s cubic-bezier(0.2, 0, 0, 1), opacity 0.08s ease-out';
export const SWIPE_OUT_TRANSITION =
  'transform 0.3s cubic-bezier(0.2, 0, 0, 1), opacity 0.08s ease-out';
